import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HamburgerMenu() {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleReturnWebim = () => {
    setOpen(false);
    navigate('/');
  };

  return (
    <div className="hamburger-wrap" ref={menuRef}>
      {/* <button
        type="button"
        className="hamburger-btn"
        //onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-haspopup="true"
        aria-label="Menu"
      >
        <span className="hamburger-line" />
        <span className="hamburger-line" />
        <span className="hamburger-line" />
      </button>
      {open ? (
        <div className="hamburger-dropdown" role="menu">
          {/* <button type="button" className="hamburger-dropdown-item" role="menuitem" onClick={handleReturnWebim}>
            Return to WebIM
          </button> */}
    </div>
  );
}
